import { render, staticRenderFns } from "./RegistrationMembers.vue?vue&type=template&id=04613a7b&scoped=true"
import script from "./RegistrationMembers.vue?vue&type=script&lang=js"
export * from "./RegistrationMembers.vue?vue&type=script&lang=js"
import style0 from "./RegistrationMembers.vue?vue&type=style&index=0&id=04613a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04613a7b",
  null
  
)

export default component.exports